<template>
  <div class="header">
    <el-header height="100" style="width:100%;">
      <div class="top">
        <div class="logo">
          <img src="../assets/img/street/home-logo.png"  alt/>
        </div>
        <div class="index-header-right">
          <div class="index-nav">
            <a href="">
              <i><img src="~@/assets/img/street/index-icon-home.png" alt/></i>
              <span>首页</span>
            </a>
            <a @click="handleRouterPath('forTheDuty')">
              <i><img src="~@/assets/img/street/index-icon-bfzb.png" alt/></i>
              <span>备防值班</span>
            </a>
            <a @click="handleRouterPath('personManage')">
              <i><img src="~@/assets/img/street/index-icon-rygl.png" alt/></i>
              <span>人员管理</span>
            </a>
            <a @click="handleRouterPath('equiManage')">
              <i><img src="~@/assets/img/street/index-icon-zbgl.png" alt/></i>
              <span>装备管理</span>
            </a>
            <a @click="handleRouterPath('pullDrillDangers')">
              <i><img src="~@/assets/img/street/index-icon-ldjl.png" alt/></i>
              <span>拉动记录</span>
            </a>
            <a @click="handleRouterPath('operation')">
              <i><img src="~@/assets/img/street/index-icon-czjc.png" alt/></i>
              <span>操作教程</span>
            </a>
          </div>
          <div class="userName">
            <el-dropdown>
              <div class="el-dropdown-link">
                <span class="name-pic"><img src="~@/assets/img/icon-user.png" alt=""></span>
                <span class="name-text">{{ name }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleSignOut">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </el-header>
  </div>
</template>
<script>
import store from '@/store/index';

export default {
  data() {
    return {
      name: store.state.name
    };
  },
  methods: {
    handleRouterPath(val) {
      if (val === 'forTheDuty') {
        this.$router.push("/forTheDuty");
      }
      if (val === 'personManage') {
        this.$router.push("/personManage");
      }
      if (val === 'equiManage') {
        this.$router.push("/equiManage");
      }
      if (val === 'operateShifts') {
        this.$router.push('/operateShifts');
      }
      if (val === 'pullDrillDangers') {
        this.$router.push("/pullDrillDangers");
      }
      if (val === 'operation') {
        this.$router.push("/operation");
      }
     if (val === "loraEquipment") {
      this.$router.push("loraEquipment");
     }
    },
    handleSignOut() {
      let _this = this;
      this.$router.push("/")
      _this.$store.commit('clearLoginInfo');
      _this.$root.eventHub.$emit('initWebsocket');
    }
  }
};
</script>
<style lang="less" scoped>
html,
body {
  background: #fff;
}

.el-header {
  padding: 0;
}

.header {
  .index-header-right {
    float: right;
  }

  .index-nav {
    float: left;
    padding-right: 70px;

    a {
      text-align: center;
      text-decoration: none;
      padding: 17px 25px 16px;
      float: left;
      cursor: pointer;

      i {
        display: block;
        height: 31px;
        margin-bottom: 15px;
      }

      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
      }
    }

    a:hover, a.active {
      background: #2A2C38;
      transition: .3s;
    }
  }

  .top {
    background: #353945;
    width: 100%;
    height: 100px;
    overflow: hidden;

    .logo {
      float: left;
      padding: 20px 25px 20px 53px;

      img {
        width: 100%;
      }
    }

    .topic {
      font-size: 28px;
      font-weight: bold;
      color: #fff;
      float: left;
      line-height: 100px;
    }

    .userPhoto {
      float: right;
      margin: 10px 29px;

      img {
        width: 100%;
        display: block;
        border-radius: 50%;
      }
    }

    .userName {
      float: right;
      cursor: pointer;
      background: url("~@/assets/img/icon-user-bg.png") no-repeat;
      width: 190px;
      height: 70px;
      margin: 15px 20px 15px 0px;

      .el-dropdown-link {
        float: left;

        span.name-pic {
          float: left;
          padding: 16px 10px 16px 20px;

          img {
            width: 38px;
            height: 38px;
          }
        }

        span.name-text {
          float: left;
          margin-top: 29px;
          line-height: 12px;
          width: 80px;
          color: #fff;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 12px;
        }

        i.el-icon-arrow-down {
          margin-top: 29px;
        }
      }

      .el-select {
        width: 120px;
        border: none;
        height: 80px;
      }
    }
  }
}
</style>
<style>
.el-icon-arrow-down:before {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/headerAll.vue